import RadioInput from '@core/components/radioinput/RadioInput';
import React from 'react';

import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { useInfiniteQuery } from 'react-query';
import { coverLetterAll } from 'services/coverLetter';
import { getAccessToken } from 'utils/authentication';

import Loading from '@core/components/loading/Loading';
import LinkButton from '@core/components/linkbutton/LinkButton';

import classes from './CoverLetterList.module.scss';


const CoverLetterList = ({ setSelectedCoverLetter }) => {

    const { data, isLoading, refetch, fetchNextPage, isFetchingNextPage, hasNextPage } = useInfiniteQuery(
        ['cover-letter-content', getAccessToken()],
        ({ pageParam = 1 }) => coverLetterAll.GET(`?status=exported&page=${pageParam}`),
        {
            getNextPageParam: (lastpage, pages) => {
                if (lastpage.data?.next) {
                    return pages.length + 1;
                }
                return;
            }
        }

    );
    const CoverLetterArray = data?.pages?.reduce((finalArray, currentPage) => {
        if (currentPage?.data?.results) {
            return [...finalArray, ...currentPage.data.results];
        } else {
            return finalArray;
        }
    }, []);

    const scrolledBottom = () => {
        if (hasNextPage) {
            fetchNextPage();
        }
    };
    const coverLetterContainerRef = useBottomScrollListener(scrolledBottom);

    return (
        <div ref={coverLetterContainerRef} className={classes['cover-letters-wrapper']}>
            {data && !isLoading && (
                <>
                    {CoverLetterArray.map((coverLetter) => (
                        <div key={coverLetter.id} className='d-flex align-items-center justify-content-between mb-2'>
                            <RadioInput
                                input={{
                                    name: `cove-letter`,
                                    label: `${coverLetter.name}`,
                                    id: `cove_letter_${coverLetter.id}`,
                                }}
                                onChange={() => setSelectedCoverLetter(coverLetter.id)}
                            />
                            <span>
                                {coverLetter.created_date}
                            </span>
                        </div>
                    ))}
                    {data && CoverLetterArray.length === 0 && (
                        <div className={classes['no-coverletter']}>
                            <span>Pharmuni Cover Letter</span>
                            <LinkButton to={'/cover-letter'}>Create your pharmuni cover letter</LinkButton>
                        </div>
                    )}
                </>
            )}
            {isFetchingNextPage && (<Loading />)}
        </div >
    );
};

export default CoverLetterList;